import Vue from 'vue'
import Vuex from 'vuex'
import plugins from './plugins/plugins'

// 全局通用
import menu from './modules/menu'
import table from './modules/table'
import user from './modules/user'
import followCustom from './modules/followCustom'
import global from './modules/global'
import productManage from './modules/productManage'
// 二级菜单
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // 全局
    menu,
    table,
    user,
    followCustom,
    global,
    productManage,
    // 二级菜单
  },
  plugins,
  scrict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/store/index.js